import DatePicker from "react-datepicker";
import { getMonth, getYear } from "date-fns";
import { useSettings } from "../../context/settings";

const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

function DateTimeInput({ value, onChange, ...props }) {
  const { datePickerFormat } = useSettings();
  const currentYear = getYear(new Date()) + 50;
  const years = Array.from({ length: currentYear - 1940 + 1 }, (_, i) => 1940 + i);

  return (
    <DatePicker
      selected={value}
      onChange={onChange}
      className="form-control"
      dateFormat={datePickerFormat}
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 4,
            padding: "0px 2px",
          }}
        >
          <button
            type="button"
            className="btn btn-sm btn-light"
            onClick={decreaseMonth}
            disabled={prevMonthButtonDisabled}
          >
            {"<"}
          </button>

          <div style={{ display: "flex", gap: 4 }}>
            <select
              className="form-select form-select-sm"
              value={MONTHS[getMonth(date)]}
              onChange={({ target: { value } }) => changeMonth(MONTHS.indexOf(value))}
            >
              {MONTHS.map((month) => (
                <option key={month} value={month}>
                  {month}
                </option>
              ))}
            </select>

            <select
              className="form-select form-select-sm"
              value={getYear(date)}
              onChange={({ target: { value } }) => changeYear(Number(value))}
            >
              {years.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>

          <button
            type="button"
            className="btn btn-sm btn-light"
            onClick={increaseMonth}
            disabled={nextMonthButtonDisabled}
          >
            {">"}
          </button>
        </div>
      )}
      {...props}
    />
  );
}

export default DateTimeInput;
